import React, { Component, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlatList from 'flatlist-react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, Menu, ListItem, ListItemIcon, ListItemText, Button, TextField } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { TimeIcon, BackIcon, MopedIcon, PlaceIcon, PhoneIcon, ErrorIcon, EditWhiteSmallIcon, DeliveryIcon, SuccessIcon } from '../../components/icons'
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker';
import Divider from '../../components/Divider'
import { formatDateTimeFrEpoch, formatTimeFrEpoch } from '../../utils/util';
import Container from '../../components/Container';
import { clearOrder, getOrderCache, order_key, setOrderCache } from '../../utils/order_cache';
import { callCartItemListeners, callRefreshMyOrderListeners, getAddCardInfo, getCurrency, getLogo, getTopupInfo, initOptionHeader } from '../../utils/common';
import crmservices from '../../wsclient/';
import ModalAlert from '../../components/ModalAlert';
import MenuItemsController from '../orders/MenuItemsController';
import { paths } from '../../../portal.router.config';
function ProcessAddCardSecure(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [ready, setReady] = useState(false);
    const [isAddCardSuccess, setIsAddCardSuccess] = useState(false);
    const [showCart, setShowCart] = useState(false);

    useEffect(()=>{
        init();
    },[])

    const init = async() =>{
        onShowLoading(true);

        let path = window.location.pathname;
        let addCardInfo = getAddCardInfo();
        let token = addCardInfo && addCardInfo.token? addCardInfo.token:'';
        let fromOrder = addCardInfo && addCardInfo.fromOrder? addCardInfo.fromOrder:'';

        if(token && path && path.search(token)>0 && path.includes('success')){
            setReady(true);
            setIsAddCardSuccess(true);
            if(fromOrder){
                setShowCart(true);
            }
        }
        else{
            setReady(true);
            setIsAddCardSuccess(false);
        }
        onShowLoading(false);
    }
    const showMessage = (status, message) =>{
        onShowLoading(false);
        setMessage({
                show: status,
                content: message ? message : null
        })
    }

    const { classes, t } = props;
    if(ready)
        return (
            <Container showLoading={showLoading}>
                <Grid xs={12} item justify='center' container>
                    <Grid xs={12} sm={12} md={8} lg={6} item>
                        <Grid xs={12} item justify='center' container style={{ marginTop: 16 }}>
                            {isAddCardSuccess == true && <SuccessIcon style={{ width: 100, height: 100 }} />}
                            {isAddCardSuccess == false && <ErrorIcon style={{ width: 100, height: 100 }} />}
                        </Grid>
                        <Grid xs={12} item justify='center' container style={{ marginBottom: 16 }}>
                            {isAddCardSuccess == true && <Typo light variant="subtitle1" mg_top_xl>{t('ADDCARD_SUCCESS')}</Typo>}
                            {isAddCardSuccess == false && <Typo light variant="subtitle1" mg_top_xl>{t('ADDCARD_FAILED')}</Typo>}
                        </Grid>
                    </Grid>
                </Grid>
                {message && <ModalAlert
                    open={message.show}
                    onClose={showMessage}
                    message={message.content}
                />}
                {showCart && <MenuItemsController open={showCart} onClose={() => setShowCart(false)} openFromHeader />}
            </Container >
        );
    else{
        return(
            <Container showLoading={showLoading}>

            </Container>
        )
    }    

}


const styles = theme => ({
    content: {
        margin: theme.spacing(4, 0, 4, 0)
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '47%',
        [theme.breakpoints.down('md')]: {
            width: '54%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '63%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%'
        }
    },
    row: {
        margin: theme.spacing(2, 0, 2, 0)
    },
    item_image: {
        width: theme.spacing(9),
        height: theme.spacing(9),
        objectFit: 'containt',
        borderRadius: theme.spacing(9),
    },
    item_image_container: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(10),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
    },
    listItem: {
        marginTop: theme.spacing(7)
    },
    item: {
        margin: theme.spacing(5, 0, 5, 0)
    },
    item_icon_container: {
        // marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.button.category.backgroundColor,
    },
});
export default withStyles(styles)(withTranslation()(ProcessAddCardSecure));